import{d as o}from"./chunk-XWRW4TO4.js";import{a as n}from"./chunk-RULY5VOQ.js";import{m as s}from"./chunk-HBP5N4FR.js";s();var f=e=>{let r=o(n);if(!!e)return r.signedSessions[e]};export{f as a};
//# sourceMappingURL=chunk-PK3B7MMU.js.map
